import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

const CARD_KEYS = [
  'whatIs',
  'whyExists',
  'engineering',
  'sovereignty',
  'audience',
  'status',
] as const

export function LandingCards(): ReactElement {
  const { t } = useTranslation('common')

  return (
    <section className="lp-platform">
      <div className="lp-platform-header">
        <h2 className="lp-platform-title">
          {t('landing.platform.titlePrefix')}{' '}
          <span className="lp-platform-title-accent">{t('landing.platform.titleAccent')}</span>
        </h2>
      </div>
      <div className="lp-card-grid">
        {CARD_KEYS.map((key) => (
          <div key={key} className="lp-card">
            <p className="lp-card-label">{t(`landing.platform.cards.${key}.label`)}</p>
            <p className="lp-card-title">{t(`landing.platform.cards.${key}.title`)}</p>
            <p className="lp-card-body">{t(`landing.platform.cards.${key}.body`)}</p>
          </div>
        ))}
      </div>
    </section>
  )
}
